var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconManagemnent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.8752 33.9743H40.6669C43.7306 33.9743 46.2086 31.4061 46.2086 28.2308C46.2086 25.0554 43.7306 22.4872 40.6669 22.4872C40.0811 22.4872 39.5111 22.5856 38.9806 22.7579C39.044 22.4051 39.0836 22.0359 39.0836 21.6666C39.0836 18.4913 36.6056 15.9231 33.5419 15.9231C32.1565 15.9231 30.8977 16.4564 29.924 17.3261C28.8473 14.1261 25.9102 11.8205 22.4586 11.8205C18.0886 11.8205 14.5419 15.4964 14.5419 20.0256C14.5419 20.8872 14.6765 21.7241 14.914 22.5036C12.0561 22.7333 9.7998 25.2031 9.7998 28.2225C9.7998 31.3979 12.2777 33.9661 15.3415 33.9661H16.1331",
    stroke: "#0068B5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9395 17.3179C30.1453 17.9169 30.2799 18.5487 30.3432 19.2051",
    stroke: "#0068B5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9807 22.7579C38.8541 23.4308 38.6166 24.0626 38.292 24.6205",
    stroke: "#0068B5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9062 22.5036C15.595 22.4462 16.2917 22.5283 16.9646 22.7416",
    stroke: "#0068B5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 25.7692C32.37 25.7692 35.9167 29.4451 35.9167 33.9744V36.4359",
    stroke: "#0068B5",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8558 38.0769C33.4863 40.5302 30.9292 42.1795 28 42.1795",
    stroke: "#0068B5",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.292 33.9744L35.917 36.4359L33.542 33.9744",
    stroke: "#0068B5",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9997 42.1795C23.6297 42.1795 20.083 38.5036 20.083 33.9744V31.5128",
    stroke: "#0068B5",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1445 29.8719C22.5141 27.4185 25.0712 25.7693 28.0004 25.7693",
    stroke: "#0068B5",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.708 33.9744L20.083 31.5128L22.458 33.9744",
    stroke: "#0068B5",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1295"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 32,
    fill: "white",
    transform: "translate(9 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconManagemnent);
export default __webpack_public_path__ + "static/media/icon_managemnent.8f001600ef54aa1e640c6ec7004c9b1e.svg";
export { ForwardRef as ReactComponent };